<script>
    import { navigate } from 'svelte-routing';

    function goToAboutPage() {
        navigate('/appointment');
    }
</script>


<div class="flex-row-gap" style="flex-direction: column;">
    <div class="default-button" style="font-size: 22px;" on:click={goToAboutPage}>
        Fissa un appuntamento
    </div>
</div>


<style>
    .flex-row-gap{
        margin: 5% 0;
        display: flex;
        flex-direction: row;
        gap:10px;
        align-items: center;
        justify-content: center;
    }
    .default-button {
        background: #8ba3f2;
        background: #eca8ca;
        border: 1px solid #eca8ca;
        border-radius: 6px;
        box-shadow: rgba(0, 0, 0, 0.1) 1px 2px 4px;
        box-sizing: border-box;
        color: #FFFFFF;
        cursor: pointer;
        display: inline-block;
        font-size: 16px;
        font-weight: 600;
        line-height: 30px;
        min-height: 40px;
        outline: 0;
        padding: 14px 5px;
        text-align: center;
        text-rendering: geometricprecision;
        text-transform: none;
        user-select: none;
        -webkit-user-select: none;
        touch-action: manipulation;
        vertical-align: middle;
        width: 40%;
    }
    .default-button:hover,
    .default-button:active {
        background-color: white;
        background-position: 0 0;
        color: #eca8ca;
    }
    .default-button:active {
        opacity: .5;
    }
    @media (max-width: 768px) {
        .flex-row-gap{
            flex-direction: column;
            margin-bottom: 7%;
        }
        .default-button{
            width: 95vw;
        }
    }
</style>